export enum ImageUrl {
  INFO_ICON = 'https://storage.googleapis.com/genica-webflow-assets/images/info-icon.svg',
  INFO_ICON_HOVER = 'https://storage.googleapis.com/genica-webflow-assets/images/info-icon-hover.svg',
  CLOCK_ICON = 'https://storage.googleapis.com/genica-webflow-assets/images/clock-icon.svg',
  PRICE_ICON = 'https://storage.googleapis.com/genica-webflow-assets/images/price-icon.svg',
  SAMPLE_ICON_EMPTY = 'https://storage.googleapis.com/genica-webflow-assets/images/sample-icon-empty.png',
  BG_IMAGE = 'https://storage.googleapis.com/genica-webflow-assets/images/shape-1-pricing-startup-x-template.svg',
  DROPDOWN_ARROW = 'https://storage.googleapis.com/genica-webflow-assets/images/dropdown-icon.svg',
}
